import { AssessmentDefinition, CalculationType, InputType, SideType } from '../models/assessment-definition.model';

export const ARATDefinition: AssessmentDefinition = {
  id: 'arat',
  version: '1.0',
  name: 'Action Research Arm Test',
  shortName: 'ARAT',
  description:
    'Der Action Research Arm Test bewertet die Arm- und Handfunktion nach Schlaganfall oder anderen Verletzungen des Zentralnervensystems.',
  guide:
    '<p>Der ARAT besteht aus 19 Aufgaben, die in 4 Untergruppen eingeteilt sind: Greifen, Griff, Klemmen und Grobmotorik. Jede Aufgabe wird auf einer 4-Punkte-Skala (0-3) bewertet.</p>',
  groups: [
    {
      id: 'arat-group-1',
      title: 'Greifen',
      description: 'Aufgaben zum Greifen von Objekten',
      guide:
        '<p>Bei diesen Aufgaben muss der Patient verschiedene Objekte greifen und auf eine Ablage legen.</p><p><strong>Bewertung:</strong><br>3: Bewegt normal<br>2: Vollständig ausgeführt, aber abnormal<br>1: Teilweise ausgeführt<br>0: Kann nicht ausgeführt werden</p>',
      tasks: [
        {
          id: 'arat-task-1',
          title: '1. Holzwürfel (10 cm)',
          description: 'Greifen eines 10 cm Holzwürfels',
          guide:
            '<p><strong>Anleitung:</strong> Der Patient soll einen 10 cm Holzwürfel greifen und auf die Ablage legen.</p><p><strong>Bewertung:</strong><br>3: Bewegt normal<br>2: Vollständig ausgeführt, aber abnormal<br>1: Teilweise ausgeführt<br>0: Kann nicht ausgeführt werden</p>',
          inputType: InputType.RadioGroup,
          options: [
            { value: 0, label: '0', description: 'Kann nicht ausgeführt werden' },
            { value: 1, label: '1', description: 'Teilweise ausgeführt' },
            { value: 2, label: '2', description: 'Vollständig ausgeführt, aber abnormal' },
            { value: 3, label: '3', description: 'Bewegt normal' },
          ],
          minValue: 0,
          maxValue: 3,
          defaultValue: null,
          isRequired: true,
          sideType: SideType.Both,
          icfCategories: [
            { code: 'd430', description: 'Gegenstände anheben und tragen' },
            { code: 'd440', description: 'Feinmotorischer Handgebrauch' },
            { code: 'd445', description: 'Hand- und Armgebrauch' },
          ],
        },
        {
          id: 'arat-task-2',
          title: '2. Holzwürfel (2,5 cm)',
          description: 'Greifen eines 2,5 cm Holzwürfels',
          guide:
            '<p><strong>Anleitung:</strong> Der Patient soll einen 2,5 cm Holzwürfel greifen und auf die Ablage legen.</p><p><strong>Bewertung:</strong><br>3: Bewegt normal<br>2: Vollständig ausgeführt, aber abnormal<br>1: Teilweise ausgeführt<br>0: Kann nicht ausgeführt werden</p>',
          inputType: InputType.RadioGroup,
          options: [
            { value: 0, label: '0', description: 'Kann nicht ausgeführt werden' },
            { value: 1, label: '1', description: 'Teilweise ausgeführt' },
            { value: 2, label: '2', description: 'Vollständig ausgeführt, aber abnormal' },
            { value: 3, label: '3', description: 'Bewegt normal' },
          ],
          minValue: 0,
          maxValue: 3,
          defaultValue: null,
          isRequired: true,
          sideType: SideType.Both,
          icfCategories: [
            { code: 'd430', description: 'Gegenstände anheben und tragen' },
            { code: 'd440', description: 'Feinmotorischer Handgebrauch' },
            { code: 'd445', description: 'Hand- und Armgebrauch' },
          ],
        },
        {
          id: 'arat-task-3',
          title: '3. Holzwürfel (5 cm)',
          description: 'Greifen eines 5 cm Holzwürfels',
          guide:
            '<p><strong>Anleitung:</strong> Der Patient soll einen 5 cm Holzwürfel greifen und auf die Ablage legen.</p><p><strong>Bewertung:</strong><br>3: Bewegt normal<br>2: Vollständig ausgeführt, aber abnormal<br>1: Teilweise ausgeführt<br>0: Kann nicht ausgeführt werden</p>',
          inputType: InputType.RadioGroup,
          options: [
            { value: 0, label: '0', description: 'Kann nicht ausgeführt werden' },
            { value: 1, label: '1', description: 'Teilweise ausgeführt' },
            { value: 2, label: '2', description: 'Vollständig ausgeführt, aber abnormal' },
            { value: 3, label: '3', description: 'Bewegt normal' },
          ],
          minValue: 0,
          maxValue: 3,
          defaultValue: null,
          isRequired: true,
          sideType: SideType.Both,
          icfCategories: [
            { code: 'd430', description: 'Gegenstände anheben und tragen' },
            { code: 'd440', description: 'Feinmotorischer Handgebrauch' },
            { code: 'd445', description: 'Hand- und Armgebrauch' },
          ],
        },
        {
          id: 'arat-task-4',
          title: '4. Holzwürfel (7,5 cm)',
          description: 'Greifen eines 7,5 cm Holzwürfels',
          guide:
            '<p><strong>Anleitung:</strong> Der Patient soll einen 7,5 cm Holzwürfel greifen und auf die Ablage legen.</p><p><strong>Bewertung:</strong><br>3: Bewegt normal<br>2: Vollständig ausgeführt, aber abnormal<br>1: Teilweise ausgeführt<br>0: Kann nicht ausgeführt werden</p>',
          inputType: InputType.RadioGroup,
          options: [
            { value: 0, label: '0', description: 'Kann nicht ausgeführt werden' },
            { value: 1, label: '1', description: 'Teilweise ausgeführt' },
            { value: 2, label: '2', description: 'Vollständig ausgeführt, aber abnormal' },
            { value: 3, label: '3', description: 'Bewegt normal' },
          ],
          minValue: 0,
          maxValue: 3,
          defaultValue: null,
          isRequired: true,
          sideType: SideType.Both,
          icfCategories: [
            { code: 'd430', description: 'Gegenstände anheben und tragen' },
            { code: 'd440', description: 'Feinmotorischer Handgebrauch' },
            { code: 'd445', description: 'Hand- und Armgebrauch' },
          ],
        },
        {
          id: 'arat-task-5',
          title: '5. Holzkugel (7,5 cm)',
          description: 'Greifen einer 7,5 cm Holzkugel',
          guide:
            '<p><strong>Anleitung:</strong> Der Patient soll eine 7,5 cm Holzkugel greifen und auf die Ablage legen.</p><p><strong>Bewertung:</strong><br>3: Bewegt normal<br>2: Vollständig ausgeführt, aber abnormal<br>1: Teilweise ausgeführt<br>0: Kann nicht ausgeführt werden</p>',
          inputType: InputType.RadioGroup,
          options: [
            { value: 0, label: '0', description: 'Kann nicht ausgeführt werden' },
            { value: 1, label: '1', description: 'Teilweise ausgeführt' },
            { value: 2, label: '2', description: 'Vollständig ausgeführt, aber abnormal' },
            { value: 3, label: '3', description: 'Bewegt normal' },
          ],
          minValue: 0,
          maxValue: 3,
          defaultValue: null,
          isRequired: true,
          sideType: SideType.Both,
          icfCategories: [
            { code: 'd430', description: 'Gegenstände anheben und tragen' },
            { code: 'd440', description: 'Feinmotorischer Handgebrauch' },
            { code: 'd445', description: 'Hand- und Armgebrauch' },
          ],
        },
        {
          id: 'arat-task-6',
          title: '6. Stein (10 × 2,5 × 1 cm)',
          description: 'Greifen eines Steins (10 × 2,5 × 1 cm)',
          guide:
            '<p><strong>Anleitung:</strong> Der Patient soll einen Stein (10 × 2,5 × 1 cm) greifen und auf die Ablage legen.</p><p><strong>Bewertung:</strong><br>3: Bewegt normal<br>2: Vollständig ausgeführt, aber abnormal<br>1: Teilweise ausgeführt<br>0: Kann nicht ausgeführt werden</p>',
          inputType: InputType.RadioGroup,
          options: [
            { value: 0, label: '0', description: 'Kann nicht ausgeführt werden' },
            { value: 1, label: '1', description: 'Teilweise ausgeführt' },
            { value: 2, label: '2', description: 'Vollständig ausgeführt, aber abnormal' },
            { value: 3, label: '3', description: 'Bewegt normal' },
          ],
          minValue: 0,
          maxValue: 3,
          defaultValue: null,
          isRequired: true,
          sideType: SideType.Both,
          icfCategories: [
            { code: 'd430', description: 'Gegenstände anheben und tragen' },
            { code: 'd440', description: 'Feinmotorischer Handgebrauch' },
            { code: 'd445', description: 'Hand- und Armgebrauch' },
          ],
        },
      ],
      icfCategories: [
        { code: 'd430', description: 'Gegenstände anheben und tragen' },
        { code: 'd440', description: 'Feinmotorischer Handgebrauch' },
        { code: 'd445', description: 'Hand- und Armgebrauch' },
      ],
    },
    {
      id: 'arat-group-2',
      title: 'Griff',
      description: 'Aufgaben zum Greifen und Halten',
      guide:
        '<p>Bei diesen Aufgaben muss der Patient verschiedene Objekte greifen und halten.</p><p><strong>Bewertung:</strong><br>3: Bewegt normal<br>2: Vollständig ausgeführt, aber abnormal<br>1: Teilweise ausgeführt<br>0: Kann nicht ausgeführt werden</p>',
      tasks: [
        {
          id: 'arat-task-7',
          title: '1. Wasser von Glas zu Glas gießen',
          description: 'Wasser von einem Glas in ein anderes gießen',
          guide:
            '<p><strong>Anleitung:</strong> Der Patient soll Wasser aus einem Glas in ein anderes gießen.</p><p><strong>Bewertung:</strong><br>3: Bewegt normal<br>2: Vollständig ausgeführt, aber abnormal<br>1: Teilweise ausgeführt<br>0: Kann nicht ausgeführt werden</p>',
          inputType: InputType.RadioGroup,
          options: [
            { value: 0, label: '0', description: 'Kann nicht ausgeführt werden' },
            { value: 1, label: '1', description: 'Teilweise ausgeführt' },
            { value: 2, label: '2', description: 'Vollständig ausgeführt, aber abnormal' },
            { value: 3, label: '3', description: 'Bewegt normal' },
          ],
          minValue: 0,
          maxValue: 3,
          defaultValue: null,
          isRequired: true,
          sideType: SideType.Both,
          icfCategories: [{ code: 'd430', description: 'Gegenstände anheben und tragen' }],
        },
        {
          id: 'arat-task-8',
          title: '2. Röhrchen (2,25 × 11,5 cm) platzieren',
          description: 'Röhrchen (2,25 × 11,5 cm) platzieren',
          guide:
            '<p><strong>Anleitung:</strong> Der Patient soll ein Röhrchen (2,25 × 11,5 cm) greifen und auf die Ablage stellen.</p><p><strong>Bewertung:</strong><br>3: Bewegt normal<br>2: Vollständig ausgeführt, aber abnormal<br>1: Teilweise ausgeführt<br>0: Kann nicht ausgeführt werden</p>',
          inputType: InputType.RadioGroup,
          options: [
            { value: 0, label: '0', description: 'Kann nicht ausgeführt werden' },
            { value: 1, label: '1', description: 'Teilweise ausgeführt' },
            { value: 2, label: '2', description: 'Vollständig ausgeführt, aber abnormal' },
            { value: 3, label: '3', description: 'Bewegt normal' },
          ],
          minValue: 0,
          maxValue: 3,
          defaultValue: null,
          isRequired: true,
          sideType: SideType.Both,
          icfCategories: [{ code: 'd430', description: 'Gegenstände anheben und tragen' }],
        },
        {
          id: 'arat-task-9',
          title: '3. Röhrchen (1 × 16 cm) platzieren',
          description: 'Röhrchen (1 × 16 cm) platzieren',
          guide:
            '<p><strong>Anleitung:</strong> Der Patient soll ein Röhrchen (1 × 16 cm) greifen und auf die Ablage stellen.</p><p><strong>Bewertung:</strong><br>3: Bewegt normal<br>2: Vollständig ausgeführt, aber abnormal<br>1: Teilweise ausgeführt<br>0: Kann nicht ausgeführt werden</p>',
          inputType: InputType.RadioGroup,
          options: [
            { value: 0, label: '0', description: 'Kann nicht ausgeführt werden' },
            { value: 1, label: '1', description: 'Teilweise ausgeführt' },
            { value: 2, label: '2', description: 'Vollständig ausgeführt, aber abnormal' },
            { value: 3, label: '3', description: 'Bewegt normal' },
          ],
          minValue: 0,
          maxValue: 3,
          defaultValue: null,
          isRequired: true,
          sideType: SideType.Both,
          icfCategories: [{ code: 'd430', description: 'Gegenstände anheben und tragen' }],
        },
        {
          id: 'arat-task-10',
          title: '4. Unterlegscheibe ergreifen und aufstecken',
          description: 'Unterlegscheibe ergreifen und aufstecken',
          guide:
            '<p><strong>Anleitung:</strong> Der Patient soll eine Unterlegscheibe ergreifen und auf einen Stift stecken.</p><p><strong>Bewertung:</strong><br>3: Bewegt normal<br>2: Vollständig ausgeführt, aber abnormal<br>1: Teilweise ausgeführt<br>0: Kann nicht ausgeführt werden</p>',
          inputType: InputType.RadioGroup,
          options: [
            { value: 0, label: '0', description: 'Kann nicht ausgeführt werden' },
            { value: 1, label: '1', description: 'Teilweise ausgeführt' },
            { value: 2, label: '2', description: 'Vollständig ausgeführt, aber abnormal' },
            { value: 3, label: '3', description: 'Bewegt normal' },
          ],
          minValue: 0,
          maxValue: 3,
          defaultValue: null,
          isRequired: true,
          sideType: SideType.Both,
          icfCategories: [{ code: 'd430', description: 'Gegenstände anheben und tragen' }],
        },
      ],
      icfCategories: [{ code: 'd430', description: 'Gegenstände anheben und tragen' }],
    },
    {
      id: 'arat-group-3',
      title: 'Präzisionsgriff',
      description: 'Aufgaben zur Feinmotorik',
      guide:
        '<p>Bei diesen Aufgaben muss der Patient kleine Objekte zwischen den Fingern halten.</p><p><strong>Bewertung:</strong><br>3: Bewegt normal<br>2: Vollständig ausgeführt, aber abnormal<br>1: Teilweise ausgeführt<br>0: Kann nicht ausgeführt werden</p>',
      tasks: [
        {
          id: 'arat-task-11',
          title: '1. kleine Kugel (6 mm) mit Daumen und Ringfinger',
          description: 'Kleine Kugel (6 mm) mit Daumen und Ringfinger greifen',
          guide:
            '<p><strong>Anleitung:</strong> Der Patient soll eine kleine Kugel (6 mm) zwischen Daumen und Ringfinger greifen und transportieren.</p><p><strong>Bewertung:</strong><br>3: Bewegt normal<br>2: Vollständig ausgeführt, aber abnormal<br>1: Teilweise ausgeführt<br>0: Kann nicht ausgeführt werden</p>',
          inputType: InputType.RadioGroup,
          options: [
            { value: 0, label: '0', description: 'Kann nicht ausgeführt werden' },
            { value: 1, label: '1', description: 'Teilweise ausgeführt' },
            { value: 2, label: '2', description: 'Vollständig ausgeführt, aber abnormal' },
            { value: 3, label: '3', description: 'Bewegt normal' },
          ],
          minValue: 0,
          maxValue: 3,
          defaultValue: null,
          isRequired: true,
          sideType: SideType.Both,
          icfCategories: [{ code: 'd440', description: 'Feinmotorischer Handgebrauch' }],
        },
        {
          id: 'arat-task-12',
          title: '2. Murmel (1,5 cm) mit Daumen und Zeigefinger',
          description: 'Murmel (1,5 cm) mit Daumen und Zeigefinger greifen',
          guide:
            '<p><strong>Anleitung:</strong> Der Patient soll eine Murmel (1,5 cm) zwischen Daumen und Zeigefinger greifen und transportieren.</p><p><strong>Bewertung:</strong><br>3: Bewegt normal<br>2: Vollständig ausgeführt, aber abnormal<br>1: Teilweise ausgeführt<br>0: Kann nicht ausgeführt werden</p>',
          inputType: InputType.RadioGroup,
          options: [
            { value: 0, label: '0', description: 'Kann nicht ausgeführt werden' },
            { value: 1, label: '1', description: 'Teilweise ausgeführt' },
            { value: 2, label: '2', description: 'Vollständig ausgeführt, aber abnormal' },
            { value: 3, label: '3', description: 'Bewegt normal' },
          ],
          minValue: 0,
          maxValue: 3,
          defaultValue: null,
          isRequired: true,
          sideType: SideType.Both,
          icfCategories: [{ code: 'd440', description: 'Feinmotorischer Handgebrauch' }],
        },
        {
          id: 'arat-task-13',
          title: '3. kleine Kugel (6 mm) mit Daumen und Mittelfinger',
          description: 'Kleine Kugel (6 mm) mit Daumen und Mittelfinger greifen',
          guide:
            '<p><strong>Anleitung:</strong> Der Patient soll eine kleine Kugel (6 mm) zwischen Daumen und Mittelfinger greifen und transportieren.</p><p><strong>Bewertung:</strong><br>3: Bewegt normal<br>2: Vollständig ausgeführt, aber abnormal<br>1: Teilweise ausgeführt<br>0: Kann nicht ausgeführt werden</p>',
          inputType: InputType.RadioGroup,
          options: [
            { value: 0, label: '0', description: 'Kann nicht ausgeführt werden' },
            { value: 1, label: '1', description: 'Teilweise ausgeführt' },
            { value: 2, label: '2', description: 'Vollständig ausgeführt, aber abnormal' },
            { value: 3, label: '3', description: 'Bewegt normal' },
          ],
          minValue: 0,
          maxValue: 3,
          defaultValue: null,
          isRequired: true,
          sideType: SideType.Both,
          icfCategories: [{ code: 'd440', description: 'Feinmotorischer Handgebrauch' }],
        },
        {
          id: 'arat-task-14',
          title: '4. kleine Kugel (6 mm) mit Daumen und Zeigefinger',
          description: 'Kleine Kugel (6 mm) mit Daumen und Zeigefinger greifen',
          guide:
            '<p><strong>Anleitung:</strong> Der Patient soll eine kleine Kugel (6 mm) zwischen Daumen und Zeigefinger greifen und transportieren.</p><p><strong>Bewertung:</strong><br>3: Bewegt normal<br>2: Vollständig ausgeführt, aber abnormal<br>1: Teilweise ausgeführt<br>0: Kann nicht ausgeführt werden</p>',
          inputType: InputType.RadioGroup,
          options: [
            { value: 0, label: '0', description: 'Kann nicht ausgeführt werden' },
            { value: 1, label: '1', description: 'Teilweise ausgeführt' },
            { value: 2, label: '2', description: 'Vollständig ausgeführt, aber abnormal' },
            { value: 3, label: '3', description: 'Bewegt normal' },
          ],
          minValue: 0,
          maxValue: 3,
          defaultValue: null,
          isRequired: true,
          sideType: SideType.Both,
          icfCategories: [{ code: 'd440', description: 'Feinmotorischer Handgebrauch' }],
        },
        {
          id: 'arat-task-15',
          title: '5. Murmel (1,5 cm) mit Daumen und Ringfinger',
          description: 'Murmel (1,5 cm) mit Daumen und Ringfinger greifen',
          guide:
            '<p><strong>Anleitung:</strong> Der Patient soll eine Murmel (1,5 cm) zwischen Daumen und Ringfinger greifen und transportieren.</p><p><strong>Bewertung:</strong><br>3: Bewegt normal<br>2: Vollständig ausgeführt, aber abnormal<br>1: Teilweise ausgeführt<br>0: Kann nicht ausgeführt werden</p>',
          inputType: InputType.RadioGroup,
          options: [
            { value: 0, label: '0', description: 'Kann nicht ausgeführt werden' },
            { value: 1, label: '1', description: 'Teilweise ausgeführt' },
            { value: 2, label: '2', description: 'Vollständig ausgeführt, aber abnormal' },
            { value: 3, label: '3', description: 'Bewegt normal' },
          ],
          minValue: 0,
          maxValue: 3,
          defaultValue: null,
          isRequired: true,
          sideType: SideType.Both,
          icfCategories: [{ code: 'd440', description: 'Feinmotorischer Handgebrauch' }],
        },
        {
          id: 'arat-task-16',
          title: '6. Murmel (1,5 cm) mit Daumen und Mittelfinger',
          description: 'Murmel (1,5 cm) mit Daumen und Mittelfinger greifen',
          guide:
            '<p><strong>Anleitung:</strong> Der Patient soll eine Murmel (1,5 cm) zwischen Daumen und Mittelfinger greifen und transportieren.</p><p><strong>Bewertung:</strong><br>3: Bewegt normal<br>2: Vollständig ausgeführt, aber abnormal<br>1: Teilweise ausgeführt<br>0: Kann nicht ausgeführt werden</p>',
          inputType: InputType.RadioGroup,
          options: [
            { value: 0, label: '0', description: 'Kann nicht ausgeführt werden' },
            { value: 1, label: '1', description: 'Teilweise ausgeführt' },
            { value: 2, label: '2', description: 'Vollständig ausgeführt, aber abnormal' },
            { value: 3, label: '3', description: 'Bewegt normal' },
          ],
          minValue: 0,
          maxValue: 3,
          defaultValue: null,
          isRequired: true,
          sideType: SideType.Both,
          icfCategories: [{ code: 'd440', description: 'Feinmotorischer Handgebrauch' }],
        },
      ],
      icfCategories: [{ code: 'd440', description: 'Feinmotorischer Handgebrauch' }],
    },
    {
      id: 'arat-group-4',
      title: 'Grobmotorik',
      description: 'Aufgaben zur groben Bewegung des Arms',
      guide:
        '<p>Bei diesen Aufgaben muss der Patient den Arm in verschiedene Positionen bewegen.</p><p><strong>Bewertung:</strong><br>3: Bewegt normal<br>2: Vollständig ausgeführt, aber abnormal<br>1: Teilweise ausgeführt<br>0: Kann nicht ausgeführt werden</p>',
      tasks: [
        {
          id: 'arat-task-17',
          title: '1. Hand hinter den Kopf',
          description: 'Hand hinter den Kopf legen',
          guide:
            '<p><strong>Anleitung:</strong> Der Patient soll die Hand hinter den Kopf legen.</p><p><strong>Bewertung:</strong><br>3: Bewegt normal<br>2: Vollständig ausgeführt, aber abnormal<br>1: Teilweise ausgeführt<br>0: Kann nicht ausgeführt werden</p>',
          inputType: InputType.RadioGroup,
          options: [
            { value: 0, label: '0', description: 'Kann nicht ausgeführt werden' },
            { value: 1, label: '1', description: 'Teilweise ausgeführt' },
            { value: 2, label: '2', description: 'Vollständig ausgeführt, aber abnormal' },
            { value: 3, label: '3', description: 'Bewegt normal' },
          ],
          minValue: 0,
          maxValue: 3,
          defaultValue: null,
          isRequired: true,
          sideType: SideType.Both,
          icfCategories: [{ code: 'b760', description: 'Funktionen der Kontrolle von Willkürbewegungen' }],
        },
        {
          id: 'arat-task-18',
          title: '2. Hand auf den Kopf',
          description: 'Hand auf den Kopf bringen',
          guide:
            '<p><strong>Anleitung:</strong> Der Patient soll die Hand auf den Kopf legen.</p><p><strong>Bewertung:</strong><br>3: Bewegt normal<br>2: Vollständig ausgeführt, aber abnormal<br>1: Teilweise ausgeführt<br>0: Kann nicht ausgeführt werden</p>',
          inputType: InputType.RadioGroup,
          options: [
            { value: 0, label: '0', description: 'Kann nicht ausgeführt werden' },
            { value: 1, label: '1', description: 'Teilweise ausgeführt' },
            { value: 2, label: '2', description: 'Vollständig ausgeführt, aber abnormal' },
            { value: 3, label: '3', description: 'Bewegt normal' },
          ],
          minValue: 0,
          maxValue: 3,
          defaultValue: null,
          isRequired: true,
          sideType: SideType.Both,
          icfCategories: [{ code: 'b760', description: 'Funktionen der Kontrolle von Willkürbewegungen' }],
        },
        {
          id: 'arat-task-19',
          title: '3. Hand zum Mund',
          description: 'Hand zum Mund bringen',
          guide:
            '<p><strong>Anleitung:</strong> Der Patient soll die Hand zum Mund führen.</p><p><strong>Bewertung:</strong><br>3: Bewegt normal<br>2: Vollständig ausgeführt, aber abnormal<br>1: Teilweise ausgeführt<br>0: Kann nicht ausgeführt werden</p>',
          inputType: InputType.RadioGroup,
          options: [
            { value: 0, label: '0', description: 'Kann nicht ausgeführt werden' },
            { value: 1, label: '1', description: 'Teilweise ausgeführt' },
            { value: 2, label: '2', description: 'Vollständig ausgeführt, aber abnormal' },
            { value: 3, label: '3', description: 'Bewegt normal' },
          ],
          minValue: 0,
          maxValue: 3,
          defaultValue: null,
          isRequired: true,
          sideType: SideType.Both,
          icfCategories: [{ code: 'b760', description: 'Funktionen der Kontrolle von Willkürbewegungen' }],
        },
      ],
      icfCategories: [{ code: 'b760', description: 'Funktionen der Kontrolle von Willkürbewegungen' }],
    },
  ],
  icfCategories: [
    { code: 'd440', description: 'Feinmotorischer Handgebrauch' },
    { code: 'd445', description: 'Hand- und Armgebrauch' },
    { code: 'd430', description: 'Gegenstände anheben und tragen' },
    { code: 'b760', description: 'Funktionen der Kontrolle von Willkürbewegungen' },
  ],
  calculationType: CalculationType.Sum,
  showPercentFulfillment: true,
  showICFScore: true,
  requiresPatientData: false,
  sideType: SideType.Both,
};
